module.exports = __webpack_public_path__ + "static/media/idO.c7149576.jpeg";